import { render, staticRenderFns } from "./a.vue?vue&type=template&id=10c2c637&scoped=true&"
import script from "./a.vue?vue&type=script&lang=js&"
export * from "./a.vue?vue&type=script&lang=js&"
import style0 from "./a.vue?vue&type=style&index=0&id=10c2c637&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c2c637",
  null
  
)

export default component.exports